import { IconDownload } from "@tabler/icons-react";
import styles from "../../../../pages/TalentDashboard/Profile/profile.module.css";
import Button from "../../../UI/Button/button";

export default function DisclaimerBar({
  text,
  checked,
  onCheckedChange,
  onDownload,
}) {
  return (
    <div className={styles.disclaimerCard}>
      <label className={styles.disclaimerCheck}>
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onCheckedChange(e.target.checked)}
        />
        <span>{text}</span>
      </label>
      <Button
        variant="primary"
        className={styles.disclaimerDownload}
        leftIcon={<IconDownload size={14} />}
        disabled={!checked}
        onClick={onDownload}
      >
        Download Profile
      </Button>
    </div>
  );
}
